import {
  PostEditorRecurringInitialize,
  PostEditorRecurringReset,
  PostEditorRecurringSetInterval,
  PostEditorRecurringSetValue,
  PostEditorRecurringUpdateDateAction,
  PostEditorReducerFunction
} from '../PostEditorActions';
import { format } from 'date-fns';
import { DateTimeStringFormat } from '../../../../constants/time-formats';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { GroupPostAttributesType } from '../../../../models/post-editor';

export const recurringInitializeReducer: PostEditorReducerFunction<PostEditorRecurringInitialize['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex, value, date, type } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable<GroupPostAttributesType>(currentPost, {
      scheduling: {
        recurringValue: { $apply: current => (typeof value === 'number' ? value : current) },
        recurringType: { $apply: current => type ?? current },
        recurring: {
          active: { $set: true },
          date: { $apply: current => (date ? format(date, DateTimeStringFormat) : current) }
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, ['profileRequired']);
};

// todo this becamo obsolete, check if we can remove it
export const recurringResetReducer: PostEditorReducerFunction<PostEditorRecurringReset['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: { recurringValue: { $set: null }, recurringType: { $set: null } }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, ['profileRequired']);
};

export const recurringSetIntervalReducer: PostEditorReducerFunction<PostEditorRecurringSetInterval['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, type, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: { recurringType: { $set: type } }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};

export const recurringSetValueReducer: PostEditorReducerFunction<PostEditorRecurringSetValue['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, value, customizeIndex } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: { recurringValue: { $set: value } }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkRecurringInterval',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};

export const recurringUpdateDateReducer: PostEditorReducerFunction<PostEditorRecurringUpdateDateAction['payload']> = (
  state,
  payload
) => {
  const { update: updateImmutable } = ImmutabilityContext;
  const { postGroupIndex, date, customizeIndex } = payload;
  const formattedDate = format(date, DateTimeStringFormat);
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: { recurring: { date: { $set: formattedDate } } }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkDateAndTime',
    'checkExpiryDate',
    'pinterestDuplicatesCheck',
    'preventTwDuplicate',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};
